const indexItems = [
  { label: '韩漫推荐', icon: 'ri-bookmark-line', count: '2,836部' },
  { label: '日漫大全', icon: 'ri-book-open-line', count: '5,421部' },
  { label: '国漫排行榜', icon: 'ri-medal-line', count: '1,957部' },
  { label: '热血少年', icon: 'ri-fire-line', count: '1,203部' },
  { label: '甜蜜恋爱', icon: 'ri-heart-line', count: '1,856部' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '942部' },
  { label: '奇幻冒险', icon: 'ri-compass-3-line', count: '1,534部' },
  { label: '搞笑日常', icon: 'ri-emotion-laugh-line', count: '1,087部' },
  { label: '古风仙侠', icon: 'ri-moon-line', count: '768部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">类型索引</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">按漫画类型快速筛选，找到你的口味</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="flex items-center gap-3 bg-background-50 rounded-lg border border-background-200/70 p-4 hover:border-primary-300 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-accent-500`} />
              </div>
              <div className="min-w-0">
                <span className="block text-sm font-medium text-foreground-800">{item.label}</span>
                <span className="text-xs text-foreground-400">{item.count}部作品</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}